<template lang="html">
  <span v-if="isBtn">
    {{ mTitle || utils.truncate(addr, 11) }}
  </span>
  <b-link
    v-else
    v-b-tooltip.hover
    title="View on explorer"
    class="sib-link"
    target="_blank"
    :href.sync="link"
  >
    {{ mTitle || utils.truncate(addr, 11) }}
  </b-link>
</template>

<script>
import { startsWith } from "lodash";
import SID, { getSidAddress } from "@siddomains/sidjs";

export default {
  props: ["addr", "addrSize", "isBtn"],
  name: "AmaLink",
  data: () => ({ link: "#", mTitle: "" }),
  updated() {
    this.load();
  },
  async created() {
    let { chainId } = this.getCoreConfig();
    this.provider = await this.getProvider(parseInt(chainId));
    this.chainId = chainId;
    this.load();
  },
  methods: {
    async load() {
      const { address, name } = await this.getLinkBy(this.addr);
      this.link = address;
      this.mTitle = name;
    },
    async getLinkBy(address) {
      try {
        if (!startsWith(address, "0x")) {
          return { address: "#", name: "" };
        }
        if (this.chainId == "97") {
          return {
            address: this.utils.address(this.chainId, address),
            name: this.utils.truncate(address, 11),
          };
        }
        let myName = this.utils.truncate(address, this.addrSize || 20);
        if (!this.mStore.getSID(this.chainId, address)) {
          const sid = new SID({
            provider: this.provider,
            sidAddress: getSidAddress(this.chainId),
          });
          const name = await sid.getName(address);
          if (name && name.name) {
            myName = name.name;
            this.mStore.setSID(this.chainId, address, myName);
          }
        } else {
          myName = this.mStore.getSID(this.chainId, address);
        }
        return {
          address: this.utils.addressLink(this.chainId, address),
          name: myName,
        };
      } catch (error) {
        return {
          address: this.utils.addressLink(this.chainId, address),
          name: address,
        };
      }
    },
  },
  watch: {
    addr: function () {
      this.load();
    },
  },
};
</script>
<style lang="scss" scoped>
.sib-link {
  color: white;
  &:hover {
    text-decoration: none;
  }
}
</style>
